import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import Modal from 'react-awesome-modal'
import bgDonation from '@loyal_images/banners/modal-donation.png'
import bgDonationMobile from '@loyal_images/banners/modal-donation-mobile.png'

const modalDonationBackground = () => {
  return window.innerWidth <= 420 ? bgDonationMobile : bgDonation
}

const bgModalDonation = {
  backgroundImage: 'url(' + modalDonationBackground() + ')',
  backgroundColor: 'transparent !important',
  borderColor: 'transparent !important',
  backgroundRepeat: 'no-repeat'
}

const donationScreen = () => {
  window.location.href = '/donation'
}

class ModalEvaluationDonation extends Component {
  constructor () {
    super()
    this.state = {
      modalTitle: 'Ainda restaram alguns pontos na sua conta'
    }
  }
  render () {
    return (
      <Modal
        width={window.innerWidth <= 420 ? '336' : '640'}
        height='360'
        effect='fadeInUp'
        visible={this.props.show}
      >
        <Fragment>
          <div
            className='col-12 pt-1 pb-1 mr-auto ml-auto'
            style={bgModalDonation}
          >
            <div className='row pl-0 mr-0'>
              <div className='col-11' />
              <div className='col-1 text-right'>
                <Button
                  name={'Close'}
                  className={`btn btn-double btn-flat btn-icon-only btn-icon ${window.innerWidth <= 420 ? 'pos-relative r-2' : ''}`}
                  iconName='icon_close icon-sm color-ui-white'
                  text=''
                  onClick={this.props.onClose}
                />
              </div>
            </div>
            <div className='col-12 pt-2 pb-5'>
              <div className='row'>
                <div className='col-12'>
                  <div className='row mx-1'>
                    <div id='stepOne' className='col-12 col-md-7 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0 px-0'>
                      <h3 id='modalTitle' className='color-ui-white'>{this.state.modalTitle}</h3>
                      <p className='col-12 txt-body color-ui-white pt-2 px-0'>Você pode aproveitar para mudar a</p>
                      <p className='col-12 txt-body color-ui-white pt-0 px-0'>realidade de diversas pessoas e fazer uma <strong>Doação para o Movimento Solidário</strong>.</p>
                      <p className='col-12 txt-body color-ui-white pb-2 px-0'>Sua contribuição faz toda a diferença!</p>
                      <div className='col-12 px-0'>
                        <Button
                          id={'btn-next-rating'}
                          name={'btn-next-rating'}
                          className='btn btn-double btn-featured btn-rating-modal2 col-12'
                          text='QUERO FAZER A DIFERENÇA'
                          onClick={() => donationScreen()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </Modal>
    )
  }
}

ModalEvaluationDonation.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.bool
}

export default ModalEvaluationDonation



// WEBPACK FOOTER //
// ./src/features/Confirmation/ModalEvaluationDonation/ModalEvaluationDonation.js